import { ReactElement } from "react";
import { Grid, Button } from "@chakra-ui/react";
import clsx from "clsx";

/**
 * 解析結果グラフ画面 レイアウトパーツ: 期間指定タブ
 * @param props
 * @constructor
 */

interface SegmentedControlProps {
  onChanged: (value: number) => void;
  inActiveColor: string;
  activeColor: string;
  activeTextColor: string;
  inActiveTextColor: string;
  values: Array<string>;
  value: number;
}

export default function SegmentedControl(
  props: Readonly<SegmentedControlProps>,
): ReactElement {
  const handleAlignment = (value: number): void => {
    if (value !== null) {
      props.onChanged(value);
    }
  };

  return (
    <Grid
      templateColumns={`repeat(${props.values.length}, 1fr)`}
      w="full"
      sx={{
        ".analysis_term_item": {
          borderRadius: "0px",
          backgroundColor: "primary.theme_lv3",
          color: "primary.theme_lv1",
        },
        ".analysis_term_item.active": {
          backgroundColor: "primary.theme_lv1",
          color: "white",
        },
        ".analysis_term_item:nth-of-type(1)": {
          borderTopLeftRadius: "999px",
          borderBottomLeftRadius: "999px",
        },
        ".analysis_term_item:nth-of-type(3)": {
          borderTopRightRadius: "999px",
          borderBottomRightRadius: "999px",
        },
      }}
    >
      {props.values.map((value, index) => (
        <Button
          variant="unstyled"
          className={clsx({
            analysis_term_item: true,
            active: index === props.value,
          })}
          py={{ base: 2, md: 2.5 }}
          key={index}
          onClick={() => handleAlignment(index)}
        >
          {value}
        </Button>
      ))}
    </Grid>
  );
}
